/* ==========================================================================
   KHONG CO VARIANT MAC DINH  +  giu so luong khi doi vi  +  thanh "in your bag"

   Shopify luon chon san mot variant. Mockup thi khong: khach phai tu chon vi
   truoc khi mua duoc. Module nay phu mot lop "chua chon" len tren, con variant
   that van do Shopify giu -> form van hop le khi khach da chon.

   Trang thai "chua chon" (class gg-nopick tren .shopify-section cua SP chinh):
     - o chon vi hien placeholder ("Choose your tea") thay vi ten variant
     - nut Add to bag KHONG kem gia  (an .gg-btn-price)
     - trong "Your Selection" chi con thanh "In your bag" neu gio da co hang
     - bam Add to bag -> chan lai, hien loi "Choose your tea."

   Chuyen sang "da chon" khi khach bam mot .fd-option, hoac khi URL co ?variant=.
   Bam "Remove" -> ve lai "chua chon", so luong ve 1.

   GIU SO LUONG: Dawn render lai ca section khi doi variant nen o quantity moi
   luon la 1. Ta chup so cu ngay truoc khi doi va dat lai sau khi render xong.

   THANH "ALREADY IN YOUR BAG": doc /cart.js, cong cac dong cung product id.
   Gallery JS ghi de #pendingOrder.innerHTML moi lan render nen thanh nay phai
   duoc chen lai sau moi lan do.

   Cau hinh: window.ggNoDefault = { label, error, productId, cartUrl }.
   ========================================================================== */
(function () {
  'use strict';


  /* classList.add / .remove rewrite the class attribute even when the class is
     already there / already gone, and a same-value rewrite is still a mutation
     record to every observer on the page. paint() runs from an observer, so
     an unconditional remove of an absent class here kept the page's observers
     — this one, the gallery's, the sticky bar's — cycling for as long as the
     page was open. Only touch the attribute when the state actually changes. */
  function addClass(el, c) { if (el && !el.classList.contains(c)) el.classList.add(c); }
  function rmClass(el, c) { if (el && el.classList.contains(c)) el.classList.remove(c); }
  var CFG = window.ggNoDefault || {};
  var LABEL = CFG.label || 'Choose your tea';
  var ERROR = CFG.error || 'Choose your tea.';
  var PRODUCT_ID = CFG.productId || null;
  var CART_URL = CFG.cartUrl || '/cart';

  var FLAG = 'gg-nopick';
  var ERR_ID = 'flavorErrorMsg';
  var BAR_CLASS = 'pending-incart';
  var WRAP_SEL = '#flavorDropdown';
  var NAME_SEL = '#flavorDropdown .fd-trigger-name';
  var SUB_SEL = '#flavorDropdown .fd-trigger-sub';
  var ADD_SEL = 'button[name="add"], .product-form__submit';
  var STICKY_SEL = '#stickyBtn, .sticky-btn';
  var QTY_SEL = 'input[name="quantity"]';
  var HOST_SEL = '#pendingOrder';

  /* ?variant= in the address used to be read as "a flavour has been chosen".
     Dawn writes it whenever ANY option changes, so picking the Dozen, Gift Box
     or Jar card added it, and a reload, a Back visit or a shared link then
     showed "Signature Collection" as the shopper's choice when they had never
     opened the flavour list. It now counts only when a flavour really was
     picked on this product in this tab, or when the shopper follows a link
     to one flavour from another page (a collection card, an ad). */
  var PICK_KEY = 'ggPicked:' + (PRODUCT_ID || window.location.pathname);
  function rememberPick(on) {
    try {
      if (on) sessionStorage.setItem(PICK_KEY, '1');
      else sessionStorage.removeItem(PICK_KEY);
    } catch (e) {}
  }
  var picked = (function () {
    if (!/[?&]variant=/.test(window.location.search)) return false;
    try { if (sessionStorage.getItem(PICK_KEY) === '1') return true; } catch (e) {}
    var nav = (window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    if (nav.type === 'reload' || nav.type === 'back_forward') return false;
    var from = '';
    try { from = document.referrer ? new URL(document.referrer).pathname : ''; } catch (e) {}
    // No referrer is a pasted or typed address, usually copied from this
    // page after a card was picked, so it is not taken as a flavour choice.
    return !!from && from !== window.location.pathname;
  })();
  var lastScope = null;

  // So luong can giu qua mot lan doi variant.
  // Khong dung "cua so thoi gian": lam vay se de len chinh thao tac tang/giam
  // cua khach ngay sau khi chon vi. Thay vao do nho luon NODE cua o quantity:
  // Dawn doi variant bang cach render lai ca section nen o quantity la node
  // MOI -> do la dau hieu chac chan de dat lai so, va chi dat lai dung mot lan.
  var keepQty = null;
  var keepNode = null;
  var keepTimer = null;
  var settleTimer = null;

  var cartState = { qty: 0, cents: 0 };

  // Cac dropdown phu bat buoc phai chon (danh dau [data-gg-require="1"] o Liquid),
  // vd mau nap khi da chon kieu hu. Element bi thay moi lan Dawn render lai nen
  // nho theo ID chu khong nho theo node.
  var subPicked = Object.create(null);

  // Nho luon GIA TRI da chon cua tung dropdown phu. O che do property (khong co
  // variant de doi), Dawn render lai section sau moi thay doi khac -> the
  // <select name="properties[...]"> bi dung moi va mat lua chon. Nho o day de
  // dat lai, neu khong thi don hang ve property rong.
  var subValue = Object.create(null);

  var CSS = [
    // Chua chon: an tieu de + cac dong hang, nhung VAN giu thanh "in your bag"
    '.' + FLAG + ' ' + HOST_SEL + ' > *:not(.' + BAR_CLASS + '){display:none !important;}',
    '.' + FLAG + ' ' + HOST_SEL + ':not(.gg-has-incart){display:none !important;}',
    '.' + FLAG + ' .gg-btn-price{display:none !important;}',
    '.' + FLAG + ' ' + NAME_SEL + '{color:var(--support-gray,#808080);}',
    '#' + ERR_ID + '{display:none;font-family:"Montserrat",sans-serif;font-size:12.5px;line-height:1.5;color:var(--raspberry,#CE0F69);margin-top:8px;}',
    '#' + ERR_ID + '.is-on{display:block;}',
    '.gg-require-error{display:none;font-family:"Montserrat",sans-serif;font-size:12.5px;line-height:1.5;color:var(--raspberry,#CE0F69);margin-top:8px;}',
    '.gg-require-error.is-on{display:block;}',
    '.gg-invalid .fd-trigger{border-color:var(--raspberry,#CE0F69) !important;}',
    '.' + BAR_CLASS + '{display:flex;justify-content:space-between;align-items:center;gap:12px;width:100%;' +
      'font-family:"Montserrat",sans-serif;font-size:11.5px;color:var(--support-gray,#808080);' +
      'background:#F7F4F1;border:none;border-radius:0;padding:10px 12px;margin:0 0 14px;' +
      'line-height:1.5;text-align:left;cursor:pointer;text-decoration:none;box-sizing:border-box;}',
    '.' + BAR_CLASS + ':hover{background:#F2EEEA;}',
    '.' + BAR_CLASS + ' b{color:var(--ink,#2B2523);font-weight:500;}',
    '.' + BAR_CLASS + ' .r{color:var(--raspberry,#CE0F69);font-size:10.5px;letter-spacing:.06em;' +
      'text-transform:uppercase;white-space:nowrap;border-bottom:1px solid var(--raspberry,#CE0F69);padding-bottom:1px;}'
  ].join('\n');

  function injectCss() {
    if (document.getElementById('gg-nodefault-css')) return;
    var s = document.createElement('style');
    s.id = 'gg-nodefault-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function wrap() { return document.querySelector(WRAP_SEL); }
  function host() { return document.querySelector(HOST_SEL); }

  // Chi khoa san pham CHINH. Trang con co Related products / upsell — chung cung
  // dung button[name="add"], chan nham la khach khong mua duoc gi ca.
  function mainScope() {
    var w = wrap();
    if (!w) return null;
    return w.closest('.shopify-section') || w.closest('form') || null;
  }

  function ownsButton(btn) {
    if (btn.matches && btn.matches(STICKY_SEL)) return true;   // sticky bar = SP chinh
    var scope = mainScope();
    return !!(scope && scope.contains(btn));
  }

  /* ---------- dropdown phu bat buoc ---------- */

  function requiredWraps() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-gg-require="1"]'));
  }

  function keyOfWrap(w) {
    return w.id || w.getAttribute('data-prompt') || 'req';
  }

  // Tra ve wrap dau tien chua duoc chon, khong co thi null.
  function firstUnsatisfied() {
    var list = requiredWraps();
    for (var i = 0; i < list.length; i++) {
      if (!subPicked[keyOfWrap(list[i])]) return list[i];
    }
    return null;
  }

  function propSelectOf(w) {
    var scope = w.parentNode;
    return scope ? scope.querySelector('select.gg-prop-select') : null;
  }

  function subErrBox(w) {
    var id = w.id ? w.id.replace(/Dropdown$/, '') + 'ErrorMsg' : null;
    var el = id ? document.getElementById(id) : null;
    if (el) return el;
    el = w.parentNode && w.parentNode.querySelector('.gg-require-error');
    return el || null;
  }

  function showSubError(w, on) {
    var el = subErrBox(w);
    if (el) el.classList.toggle('is-on', !!on);
    w.classList.toggle('gg-invalid', !!on);
  }

  function paintRequired() {
    requiredWraps().forEach(function (w) {
      var key = keyOfWrap(w);

      if (subPicked[key]) {
        // Da chon roi: dat lai nhan + o mau + gia tri property sau moi lan render
        var saved = subValue[key];
        if (!saved) return;

        var nameEl = w.querySelector('.fd-trigger-name');
        if (nameEl && nameEl.textContent.trim() !== saved.label) {
          nameEl.textContent = saved.label;
          nameEl.style.color = '';
        }
        addClass(w, 'chosen');

        var opt = w.querySelector('.fd-option[data-value="' + saved.value.replace(/"/g, '\\"') + '"]');
        if (opt && !opt.classList.contains('selected')) {
          Array.prototype.forEach.call(w.querySelectorAll('.fd-option.selected'), function (o) {
            rmClass(o, 'selected');
          });
          addClass(opt, 'selected');
        }

        // O mau tren trigger: chep lai tu option dang chon
        var oSw = opt && opt.querySelector('.fd-option-swatch');
        var tSw = w.querySelector('.fd-trigger-swatch');
        if (oSw) {
          if (!tSw) {
            tSw = document.createElement('span');
            tSw.className = 'fd-trigger-swatch';
            var txt = w.querySelector('.fd-trigger-text');
            w.querySelector('.fd-trigger').insertBefore(tSw, txt || null);
          }
          if (tSw.getAttribute('style') !== oSw.getAttribute('style')) {
            tSw.setAttribute('style', oSw.getAttribute('style') || '');
          }
        }

        var sel = propSelectOf(w);
        if (sel && sel.value !== saved.value) {
          sel.value = saved.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
      // Chua chon: tra trigger ve nhan cho, bo dau tick Shopify dat san
      var prompt = w.getAttribute('data-prompt') || '';
      var name = w.querySelector('.fd-trigger-name');
      if (name && prompt && name.textContent.trim() !== prompt) name.textContent = prompt;
      if (name) name.style.color = 'var(--support-gray, #808080)';
      var sub = w.querySelector('.fd-trigger-sub');
      if (sub && sub.textContent.trim()) sub.textContent = '';

      // Chua chon thi KHONG hien o mau tren trigger. Gallery copy o mau tu option
      // dang duoc Shopify chon san sang trigger, nhung o trang thai cho thi trigger
      // phai trong tron — o mau chi xuat hien trong danh sach option.
      var tSw = w.querySelector('.fd-trigger-swatch');
      if (tSw) tSw.parentNode.removeChild(tSw);

      rmClass(w, 'chosen');
      Array.prototype.forEach.call(w.querySelectorAll('.fd-option.selected'), function (o) {
        rmClass(o, 'selected');
      });
    });
  }

  function qtyNow() {
    var el = document.querySelector(QTY_SEL);
    var n = el ? parseInt(el.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  var settingQty = false;

  function setQty(v) {
    var el = document.querySelector(QTY_SEL);
    if (!el) return;
    var next = String(Math.max(1, v));
    if (el.value === next) return;
    settingQty = true;
    el.value = next;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    settingQty = false;
  }

  /* ---------------- o bao loi ---------------- */

  function errBox() {
    var el = document.getElementById(ERR_ID);
    if (el) return el;
    var w = wrap();
    if (!w) return null;
    el = document.createElement('div');
    el.id = ERR_ID;
    el.setAttribute('role', 'alert');
    el.textContent = ERROR;
    w.parentNode.insertBefore(el, w.nextSibling);
    return el;
  }

  function showError(on) {
    var el = errBox();
    if (el) el.classList.toggle('is-on', !!on);
    var w = wrap();
    if (w) w.classList.toggle('gg-invalid', !!on);
  }

  /* ---------------- thanh "Already in your bag" ---------------- */

  function money(cents) {
    // Whole dollars without the .00 when the theme setting says so, written
    // here so the banner never paints $25.00 and waits for the page-wide pass.
    var whole = cents % 100 === 0 && window.gioNoCents;
    return '$' + (cents / 100).toFixed(whole ? 0 : 2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function readCart() {
    if (!PRODUCT_ID) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var qty = 0, cents = 0;
        (c.items || []).forEach(function (it) {
          if (String(it.product_id) !== String(PRODUCT_ID)) return;
          qty += it.quantity;
          cents += it.line_price;
        });
        cartState = { qty: qty, cents: cents };
        syncBar();
      })
      .catch(function () {});
  }

  // Gallery JS ghi de innerHTML cua #pendingOrder moi lan render -> chen lai.
  function syncBar() {
    var h = host();
    if (!h) return;

    if (cartState.qty <= 0) {
      var old = h.querySelector('.' + BAR_CLASS);
      if (old) old.parentNode.removeChild(old);
      rmClass(h, 'gg-has-incart');
      return;
    }

    var lead = picked ? 'Already in your bag' : 'In your bag';
    var label = lead + ': <b>' + cartState.qty + ' item' + (cartState.qty === 1 ? '' : 's') + '</b>' +
      ' &middot; ' + money(cartState.cents) + ' &mdash; counts toward your rewards';

    var bar = h.querySelector('.' + BAR_CLASS);
    if (!bar) {
      bar = document.createElement('a');
      bar.className = BAR_CLASS;
      // The bag opens over the page rather than replacing it: a shopper checking
      // what is already in there has not asked to leave the product. The href
      // stays as the fallback for a template with no drawer, and for anyone
      // opening it in a new tab.
      bar.setAttribute('href', CART_URL);
      bar.setAttribute('data-gg-open-drawer', '1');
      // Danh dau de render() cua gallery JS khong xoa mat khi cap nhat khoi
      bar.setAttribute('data-gg-keep', '1');
      bar.innerHTML = '<span class="l"></span><span class="r">View bag</span>';
    }

    // Luon tu dat lai vi tri: ngay DUOI tieu de "Your Selection", tren cac dong
    // hang. Khi gallery render lai ca khoi no tha node giu lai xuong cuoi, nen
    // khong the chi dat mot lan luc tao.
    var title = h.querySelector('.pending-order-title');
    var want = title ? title.nextSibling : h.firstChild;
    if (want !== bar) h.insertBefore(bar, want);

    var l = bar.querySelector('.l');
    // Compared against what was last WRITTEN, not against innerHTML: the label
    // holds entities (&middot;, &mdash;) and innerHTML gives back the
    // characters, so the two never matched and the line was rewritten on
    // every paint — and every paint is triggered by a mutation, so this was
    // an 80-per-second flicker on "In your bag" whenever the bag had anything
    // in it.
    if (l && l.__ggLabel !== label) { l.innerHTML = label; l.__ggLabel = label; }
    addClass(h, 'gg-has-incart');
  }

  /* ---------------- son lai giao dien ---------------- */

  // Dawn thay ca o quantity khi doi variant -> dat lai so cu.
  function clearKeep() {
    keepQty = null;
    keepNode = null;
    if (keepTimer) { clearTimeout(keepTimer); keepTimer = null; }
    if (settleTimer) { clearTimeout(settleTimer); settleTimer = null; }
  }

  function restoreQty() {
    if (keepQty == null) return;
    var el = document.querySelector(QTY_SEL);
    if (!el) return;
    if (el === keepNode) return;                       // chua render lai -> chua dung toi

    if (parseInt(el.value, 10) !== keepQty) setQty(keepQty);

    // KHONG dung lai ngay sau lan dat dau tien: Dawn render lai section theo
    // nhieu nhip, nhip sau se ghi de o quantity ve 1. Giu quyen dat lai them
    // mot khoang ngan cho DOM on dinh, roi moi buong.
    if (!settleTimer) {
      settleTimer = setTimeout(function () { settleTimer = null; clearKeep(); }, 1500);
    }
  }

  function paint() {
    var scope = mainScope() || document.body;
    if (lastScope && lastScope !== scope) rmClass(lastScope, FLAG);
    lastScope = scope;
    scope.classList.toggle(FLAG, !picked);

    syncBar();
    restoreQty();
    paintRequired();

    if (picked) return;

    var name = document.querySelector(NAME_SEL);
    if (name && name.textContent.trim() !== LABEL) name.textContent = LABEL;

    var sub = document.querySelector(SUB_SEL);
    if (sub && sub.textContent.trim()) sub.textContent = '';

    var w = wrap();
    if (w) {
      Array.prototype.forEach.call(w.querySelectorAll('.fd-option.selected'), function (o) {
        rmClass(o, 'selected');
      });
    }
  }

  function pick() {
    // Chup so luong TRUOC khi Dawn render lai — ke ca khi da o trang thai "da
    // chon", vi khach doi tu vi nay sang vi khac thi so luong phai theo sang.
    keepQty = qtyNow();
    keepNode = document.querySelector(QTY_SEL);
    if (keepTimer) clearTimeout(keepTimer);
    keepTimer = setTimeout(clearKeep, 6000);           // phao cuu sinh neu khong render lai

    rememberPick(true);
    if (picked) return;
    picked = true;
    showError(false);
    rmClass(mainScope() || document.body, FLAG);
  }

  function unpick() {
    picked = false;
    rememberPick(false);
    subPicked = Object.create(null);
    subValue = Object.create(null);
    clearKeep();                    // Remove thi so luong ve 1, khong giu
    setQty(1);

    try {
      var u = new URL(window.location.href);
      if (u.searchParams.has('variant')) {
        u.searchParams.delete('variant');
        window.history.replaceState({}, '', u.pathname + (u.search ? u.search : '') + u.hash);
      }
    } catch (e) {}

    var h = host();
    if (h) {
      var bar = h.querySelector('.' + BAR_CLASS);
      h.innerHTML = '';
      if (bar) h.appendChild(bar);   // giu lai thanh "in your bag"
    }

    paint();
    if (typeof window.ggRefreshSelection === 'function') {
      try { window.ggRefreshSelection(); } catch (e) {}
    }
    [60, 250, 600].forEach(function (ms) { setTimeout(paint, ms); });
  }

  /* ---------------- su kien ---------------- */

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var opt = e.target.closest('.fd-option, .fd-collection-row');
    // Dung contains() chu KHONG dung opt.closest(WRAP_SEL): trang cookie co ba
    // phan tu cung mang id="flavorDropdown" (vi, kieu, ribbon), closest() se
    // khop ca ribbon -> chon mau ribbon lai mo khoa nut mua ma chua chon vi.
    var w = wrap();
    if (opt && w && w.contains(opt)) pick();

    // Option cua mot dropdown phu bat buoc
    if (opt) {
      var req = opt.closest('[data-gg-require="1"]');
      if (req) {
        var k = keyOfWrap(req);
        var nameNode = opt.querySelector('.fd-option-name-text');
        subPicked[k] = true;
        subValue[k] = {
          value: opt.getAttribute('data-value') || '',
          label: opt.getAttribute('data-label') || (nameNode ? nameNode.textContent.trim() : '')
        };
        showSubError(req, false);

        // Che do property: ghi thang vao <select name="properties[...]">
        var sel = propSelectOf(req);
        if (sel) {
          sel.value = subValue[k].value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // Doi kieu dong goi -> phai chon lai cac tuy chon phu cua kieu do
    if (e.target.closest('.pkg-card')) {
      subPicked = Object.create(null);
      subValue = Object.create(null);
    }
  }, true);

  // Khach tu chinh so luong -> buong quyen dat lai ngay, thao tac cua khach thang.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-gg-step], .quantity__button, quantity-input button')) clearKeep();
  }, true);
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches(QTY_SEL) && !settingQty) clearKeep();
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest(ADD_SEL + ', ' + STICKY_SEL);
    if (!btn || !ownsButton(btn)) return;

    // Chua chon vi -> chan truoc
    if (!picked) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      showError(true);
      var w = wrap();
      if (w) w.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // Da chon vi nhung con tuy chon phu bat buoc bo trong
    var miss = firstUnsatisfied();
    if (miss) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      showSubError(miss, true);
      miss.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (picked) return;
    var f = e.target;
    if (!f || !f.querySelector || !f.querySelector(ADD_SEL)) return;
    var scope = mainScope();
    if (!scope || !scope.contains(f)) return;
    e.preventDefault();
    e.stopPropagation();
    showError(true);
  }, true);

  document.addEventListener('submit', function (e) {
    if (!picked) return;                       // da co handler o tren lo
    var miss = firstUnsatisfied();
    if (!miss) return;
    var f = e.target;
    if (!f || !f.querySelector || !f.querySelector(ADD_SEL)) return;
    var scope = mainScope();
    if (!scope || !scope.contains(f)) return;
    e.preventDefault();
    e.stopPropagation();
    showSubError(miss, true);
  }, true);

  // "Remove" trong Your Selection -> ve lai trang thai "chua chon".
  //
  // PHAI bat o pha CAPTURE. Gallery JS cua theme cung nghe nut nay o pha bubble
  // va dang ky truoc; trong handler do no render lai #pendingOrder nen nut Remove
  // bi thay bang node moi. Den luot listener bubble cua ta, e.target da roi khoi
  // DOM, closest('#pendingOrder') tra null va unpick() khong bao gio chay.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var rm = e.target.closest('[data-gg-reset], .pairing-remove');
    if (rm && rm.closest(HOST_SEL)) setTimeout(unpick, 0);
  }, true);

  // Them vao gio xong -> doc lai gio de cap nhat thanh thong bao.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest(ADD_SEL + ', ' + STICKY_SEL);
    if (btn && ownsButton(btn)) {
      [900, 2000, 3500].forEach(function (ms) { setTimeout(readCart, ms); });
    }
  });

  ['cart:refresh', 'product:added', 'cart:updated', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(readCart, 300); });
    document.documentElement.addEventListener(evt, function () { setTimeout(readCart, 300); });
  });

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; paint(); }, 0);
  }
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  injectCss();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
  window.addEventListener('load', paint);
  readCart();

  window.ggNoDefaultState = function () {
    return { picked: picked, label: LABEL, keepQty: keepQty, cart: cartState, subPicked: Object.keys(subPicked), thieu: firstUnsatisfied() ? keyOfWrap(firstUnsatisfied()) : null };
  };
  window.ggRefreshCart = readCart;

  /* ---- "View bag" opens the drawer ---------------------------------------
     Delegated, because the bar is rebuilt every time the gallery re-renders the
     block. The header's own cart control is clicked rather than calling the
     drawer directly: that is the one path on the site that opens it, so focus
     handling and the re-render behave exactly as they do everywhere else.    */
  document.addEventListener('click', function (event) {
    var bar = event.target && event.target.closest && event.target.closest('[data-gg-open-drawer]');
    if (!bar) return;

    // A new tab or a window was asked for explicitly; let the href do its job.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    var drawer = document.querySelector('cart-drawer');
    var opener = document.querySelector('#cart-icon-bubble, .header__icon--cart, a[href$="/cart"]');
    if (!drawer || !opener) return; // No drawer on this template: follow the link.

    event.preventDefault();
    opener.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
  });

})();
